import { Rate } from "../../rate/rate-type";
import { SurchargeType } from "../../surcharge-type/surcharge-type.model";

export class QuoteSurchargeType {
  constructor(
    private id: number = null,
    public rate: Rate = null,
    public surchargeType: SurchargeType = null,
    public surchargeTypeId: number = null,
  ) {}

  public getId(): number {
    return this.id;
  }
}
